import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
/**
 * The role the process is running as. One image, one entrypoint; this env var
 * selects behaviour (DECISION.md §2.2). `all` is the Checkpoint-1 shape — HTTP
 * server and job runner in one container.
 */
export const RoleSchema = z.enum(['api', 'worker', 'all']);
export const HealthResponseSchema = z
    .object({
    status: z.literal('ok'),
    /** Product name, sourced from the single brand constant (ruling R20). */
    brand: z.string(),
    role: RoleSchema,
    /** Server clock, ISO 8601. Useful for spotting clock drift between nodes. */
    time: z.iso.datetime(),
    /** Process uptime in whole seconds. */
    uptimeSeconds: z.number().int().nonnegative(),
})
    .strict();
/**
 * The health contract — the worked example that proves the contract-first
 * pipeline of DECISION.md §2.4: one Zod contract, served by NestJS via ts-rest
 * and consumed by the SPA through the same types.
 *
 * `/healthz` is unauthenticated by design and belongs to the closed set of
 * public routes named in DECISION.md §5.5 (login, password reset, health, the
 * e-invoicing authority callback). It must never return tenant data.
 */
export const healthContract = c.router({
    check: {
        method: 'GET',
        path: '/healthz',
        responses: {
            200: HealthResponseSchema,
        },
        summary: 'Liveness probe. Public by design; returns no tenant data.',
    },
}, {
    // Deliberately no pathPrefix: the probe lives at the server root so a
    // container orchestrator can reach it without knowing the API mount point.
    strictStatusCodes: true,
});
//# sourceMappingURL=health.js.map